var _style, _rect, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs2, _path8, _path9, _path10, _path11, _polygon, _defs3, _path12, _polygon2, _polygon3, _defs4, _path13, _path14, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 118.3",
    style: {
      enableBackground: "new 0 0 59 118.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007934;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_4_);fill:#007934;}\n\t.st3{fill:#404041;}\n\t.st4{clip-path:url(#SVGID_6_);fill:#404041;}\n\t.st5{clip-path:url(#SVGID_8_);fill:#404041;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.7,
    className: "st0",
    width: 58.4,
    height: 76.1
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.7,
    width: 58.6,
    height: 116.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.5,46c-1.8-3.4,0.5-5.5,1.1-7.4c0.7-2-1-3.3-1-3.3c1.1,3-1.1,4.4-1.6,6.6C24.5,44.3,26.5,46,26.5,46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,36.3c0,0.1-0.2,0.3-1,0.3c-0.4,0-1.3-0.2-1.3-0.4c0-0.1,0.3-0.3,1-0.8c0.3-0.2,0.9-0.4,1.2,0 C33.7,35.8,33.5,36.2,33.5,36.3 M41.8,32.6c-3.7,0.1-5,1.1-7.3,1.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0h0c-0.4,0-0.9,0-1.4-0.1 c-0.7-0.2-1.8-1-1.8-3.4c0-0.1,0-0.1,0-0.2c-0.1-1.3-0.1-2.3-0.1-2.2c-0.2,0.3,0,0.3-1,1.9c-0.4,0.7-0.9,1.2-1.5,2 c-0.4,0.5-0.6,1-0.6,1.4c0,0.1,0,0.2,0,0.3c-0.9,0.1-1.3,0.4-1.7,0.7c0,0,3.1,1.2,2.1,4.2c-0.9,3.1-3.1,5.4-0.6,8.6 c0,0-3.8-0.8-3.5-4.6c0.3-3,2.3-3.4,2-6.2c-0.4-3.2-4.5-2-4.8-1.8c0,0,1.1-0.1,1.7,0.8c0,0-1.3-0.3-2.6,0.8c0,0,1.9-0.5,2.5,0.8 c0.2,0.5,0.3,2.5-4.3,3.7c-5.6,1.5-7,4.8-7.5,6.3c0,0,2.5-2.9,6.8-2c0,0,0,2-3.9,3.3c-3.4,1.2-5.7,4.1-5.3,7.5c0,0,2.1-4,7.8-4.9 c0,0-0.7,4.1-7.8,8.5c0,0,4.8,0.8,6.7-1.8c0,0,1.1,4.9-5.9,8.9c0,0,6,1.1,8.4-4c0,0,0.7,2.9-0.4,5.8c0,0,1-1.8,2.8-2.3 c0,0,1.4,1.5,0.7,6.8c0,0,4-15.1,16.9-14.7c0,0-4.3-3.3-5.2-8.9c-0.2-1.5-0.2-2.8-0.2-2.8s-2.6-1-2.6-4.6c0,0,0.9,3.8,4.2,3.8 c3.2,0,4.9-2.1,7.5-4.2c1.2-1,5.4-0.3,7-0.8v-1.4h-2v-0.8h2h0v-3.9C48.4,33.8,45.7,32.5,41.8,32.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,30.3c0.1-0.4,0.3-0.6,1-1.6c0.4-0.7,1-1.5,1.3-2.4c0.3-0.8,0.4-1.7,0.4-2.4c0-0.4,0-2-0.1-1.9 c-0.1,0.1,0.1,0.3-0.6,1.6c-0.3,0.5-0.6,1.1-0.9,1.5c-0.5,0.7-0.8,1.4-0.8,1.9C28.2,27.3,27.8,30.5,27.9,30.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,24c0.1-0.4,0.2-0.6,0.7-1.3c0.5-0.7,1-1.6,1.1-2.4c0.2-0.7,0.1-1.3,0.1-1.6c0-0.3,0-1.4-0.1-1.4 c0,0,0,0.4-0.3,0.8c-0.2,0.4-0.6,1.1-0.8,1.4c-0.2,0.4-0.5,0.9-0.5,1.3C28.6,21.4,28.2,24.3,28.3,24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.1,17.4c0.3-0.6,0.6-1,0.8-1.8c0.1-0.3,0.1-0.8,0.1-1c0-0.2-0.1-1.3-0.1-1.3c0,0,0,0.2-0.3,0.9 c-0.1,0.3-0.3,0.6-0.4,0.9c-0.2,0.3-0.4,0.7-0.4,1.1c0,0.3-0.2,2.3-0.2,2.2C28.7,18,28.9,17.8,29.1,17.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.9,13.6c0.1-0.6,0.3-0.9,0.4-1.2c0.4-0.8,0.5-1.4,0.5-1.9c0-0.5-0.3-4.8-0.3-4.8s0-0.3-0.1-0.3 c-0.1,0-0.1,0.3-0.1,0.3S28.8,14.1,28.9,13.6"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,100.2H2V87.5H0.1V100.2z M0,84.7h2.2v-2.1H0V84.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    y: 0.7,
    width: 58.6,
    height: 116.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.8,87.5h1.9v2.2c0.8-1.4,2.2-2.5,4.3-2.5c3.1,0,4.9,2.1,4.9,5.1v7.9H15v-7.4c0-2.4-1.3-3.8-3.5-3.8 c-2.2,0-3.8,1.6-3.8,4v7.3H5.8V87.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.1,93.8L30.1,93.8c0-3-2.2-4.9-4.6-4.9c-2.5,0-4.5,1.8-4.5,4.9v0.1c0,3,2.1,4.9,4.5,4.9 C27.9,98.7,30.1,96.8,30.1,93.8 M19.1,93.9L19.1,93.9c0-4.2,3-6.6,6.1-6.6c2.4,0,3.9,1.3,4.9,2.7v-7.7h1.9v17.9H30v-2.5 c-1,1.5-2.5,2.8-4.9,2.8C22.1,100.4,19.1,98,19.1,93.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1,95.4v-7.9H37v7.4c0,2.4,1.3,3.8,3.5,3.8c2.2,0,3.8-1.6,3.8-4v-7.3h1.9v12.7h-1.9V98 c-0.9,1.4-2.2,2.5-4.3,2.5C36.9,100.4,35.1,98.4,35.1,95.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.8,98.5l1-1.3c1.4,1,2.9,1.6,4.4,1.6c1.5,0,2.6-0.8,2.6-2v0c0-1.3-1.5-1.8-3.2-2.2c-2-0.6-4.2-1.3-4.2-3.6 v0c0-2.2,1.8-3.6,4.3-3.6c1.5,0,3.3,0.5,4.6,1.4l-0.9,1.4c-1.2-0.8-2.5-1.2-3.8-1.2c-1.5,0-2.5,0.8-2.5,1.8v0 c0,1.2,1.6,1.7,3.3,2.2c2,0.6,4.1,1.3,4.1,3.6v0c0,2.4-2,3.8-4.5,3.8C52.2,100.4,50.2,99.7,48.8,98.5"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "0,106 0,107.1 3.1,107.1 3.1,117 4.3,117 4.3,107.1 7.3,107.1 7.3,106 "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    y: 0.7,
    width: 58.6,
    height: 116.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.9,111.6v-0.1c0-2.7-1.5-4.5-3.5-4.5s-3.5,1.9-3.5,4.5v0.1c0,2.6,1.5,4.5,3.5,4.5 C14.4,116.1,15.9,114.2,15.9,111.6 M7.6,111.6v-0.1c0-3.2,1.9-5.6,4.7-5.6c2.8,0,4.7,2.4,4.7,5.6v0.1c0,3.2-1.9,5.6-4.7,5.6 C9.5,117.2,7.6,114.8,7.6,111.6"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "24.5,106 21.9,115 19.4,106 18.1,106 21.4,117.1 22.4,117.1 25,108.2 27.6,117.1 28.6,117.1 31.9,106  30.7,106 28.1,115 25.5,106 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "33.6,106 33.6,117 40.4,117 40.4,115.9 34.8,115.9 34.8,112 39.7,112 39.7,110.9 34.8,110.9  34.8,107.1 40.3,107.1 40.3,106 "
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    y: 0.7,
    width: 58.6,
    height: 116.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46,111.7c1.8,0,2.8-0.9,2.8-2.3v0c0-1.4-1-2.2-2.6-2.2h-2.5v4.6H46z M42.5,106h3.7c1.3,0,2.3,0.4,2.9,1 c0.5,0.5,0.9,1.3,0.9,2.3v0c0,1.7-1.1,2.8-2.6,3.2l2.9,4.5h-1.4l-2.8-4.3h-2.5v4.3h-1.2V106z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.4,115.6l0.7-0.9c0.9,0.8,1.9,1.4,3.1,1.4c1.3,0,2.2-0.8,2.2-1.8v0c0-0.9-0.4-1.5-2.4-2.2 c-2.3-0.8-3.2-1.7-3.2-3.2v0c0-1.6,1.4-2.9,3.3-2.9c1.3,0,2.3,0.4,3.3,1.2l-0.7,0.9c-0.8-0.7-1.7-1.1-2.6-1.1 c-1.3,0-2.1,0.8-2.1,1.7v0c0,1,0.5,1.5,2.6,2.3c2.2,0.8,3,1.7,3,3.2v0c0,1.8-1.4,3-3.4,3C53.7,117.1,52.5,116.7,51.4,115.6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndus);
export default __webpack_public_path__ + "static/media/indus.c851589f59a95117d02630c41e62ce4c.svg";
export { ForwardRef as ReactComponent };